<template>
  <div>
    <el-alert
        v-if="!products.length"
        :closable="false"
        title="Нет данных"
        type="warning"
        style="margin-top: 20px"/>

    <div :class="['supplement-list' , add ? 'supplement-list-scroll' : '']" >
      <procedure-item v-for="product of products"
                       :key="product.id"
                       :product="product"
                       :add="add"
                        @save="save"
                        @remove="remove"/>
    </div>

    <el-button v-if="!add"
               @click.passive="openAddSupplementModal"
               type="primary"
               class="supplement-list__new-item">
      <i class="el-icon-plus"></i> Добавить услугу
    </el-button>

  </div>
</template>

<script>
import ProcedureItem from "@/components/visit/conclusion/ProcedureItem.vue"

export default {
  name: "SupplementList",
  props: {
    add: {
      type: Boolean,
      default: false
    },
    products: {
      required: true,
    },
  },
  components: {
    ProcedureItem,
  },
  data() {
    return {}
  },
  methods: {
    openAddSupplementModal() {
      this.$emit('openAddProcedureModal')
    },
    save() {
      this.$emit('save')
    },
    remove(id) {
      this.$emit('remove', id)
    },
  }
}
</script>

<style scoped lang="scss">

.supplement-list {
  //display: grid;
  //grid-template-columns: repeat(auto-fit, minmax(170px, 2fr));
  width: 100%;
  margin-top: 10px;

  &-scroll {
    max-height: 50vh;
    overflow-y: scroll;
  }

  @media (max-width: 1199px) {
    //grid-template-columns: repeat(3, 1fr);
  }

  &__new-item {
    margin-top: 14px;
    width: 100%;
    padding: 12px 0!important;
  }
}
</style>
